export const CURRENCIES = {
    AUD: {
        id: 'AUD',
        name: 'Australian dollar',
        symbol: 'A$',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: undefined,
    },
    CAD: {
        id: 'CAD',
        name: 'Canadian dollar',
        symbol: 'C$',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: undefined,
    },
    CHF: {
        id: 'CHF',
        name: 'Swiss franc',
        symbol: 'CHF',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: undefined,
    },
    CNY: {
        id: 'CNY',
        name: 'Chinese renminbi',
        symbol: '¥',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: undefined,
    },
    DKK: {
        id: 'DKK',
        name: 'Danish krone',
        symbol: 'kr',
        symbolPosition: 'suffix',
        delimiter: ',',
        numberCode: 'da-DK',
    },
    EUR: { id: 'EUR', name: 'Euro', symbol: '€', symbolPosition: 'prefix', delimiter: ',', numberCode: undefined },
    GBP: {
        id: 'GBP',
        name: 'Pound sterling',
        symbol: '£',
        symbolPosition: 'prefix',
        delimiter: ',',
        numberCode: 'en-GB',
    },
    HKD: {
        id: 'HKD',
        name: 'Hong Kong dollar',
        symbol: 'HK$',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: 'zh-HK',
    },
    HUF: {
        id: 'HUF',
        name: 'Hungarian forint',
        symbol: 'Ft',
        symbolPosition: 'suffix',
        delimiter: ',',
        numberCode: 'hu-HU',
    },
    JPY: {
        id: 'JPY',
        name: 'Japanese yen',
        symbol: '¥',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: 'ja-JP',
    },
    MXN: {
        id: 'MXN',
        name: 'Mexican peso',
        symbol: 'MX$',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: 'es-MX',
    },
    MYR: {
        id: 'MYR',
        name: 'Malaysian ringgit',
        symbol: 'RM',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: 'ms-MY',
    },
    NOK: {
        id: 'NOK',
        name: 'Norwegian krone',
        symbol: 'kr',
        symbolPosition: 'suffix',
        delimiter: ',',
        numberCode: 'nb-NO',
    },
    NZD: {
        id: 'NZD',
        name: 'New Zealand dollar',
        symbol: 'NZ$',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: 'en-NZ',
    },
    PLN: {
        id: 'PLN',
        name: 'Polish złoty',
        symbol: 'zł',
        symbolPosition: 'suffix',
        delimiter: ',',
        numberCode: 'pl-PL',
    },
    SEK: {
        id: 'SEK',
        name: 'Swedish krona',
        symbol: 'kr',
        symbolPosition: 'suffix',
        delimiter: ',',
        numberCode: 'sv-SE',
    },
    SGD: {
        id: 'SGD',
        name: 'Singapore dollar',
        symbol: 'S$',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: 'en-SG',
    },
    THB: { id: 'THB', name: 'Thai baht', symbol: '฿', symbolPosition: 'prefix', delimiter: '.', numberCode: 'th-TH' },
    USD: {
        id: 'USD',
        name: 'United States dollar',
        symbol: 'US$',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: undefined,
    },
    ZAR: {
        id: 'ZAR',
        name: 'South African rand',
        symbol: 'R',
        symbolPosition: 'prefix',
        delimiter: '.',
        numberCode: 'en-ZA',
    },
};
